module.exports = __webpack_public_path__ + "img/iconver.651a5684.png";